import { render } from "./duanqi_roster.vue?vue&type=template&id=86393008&scoped=true"
import script from "./duanqi_roster.vue?vue&type=script&lang=js"
export * from "./duanqi_roster.vue?vue&type=script&lang=js"

import "./duanqi_roster.vue?vue&type=style&index=0&id=86393008&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86393008"]])

export default __exports__